import { Link } from 'react-router-dom';

export default function Footer() {

  return (
    <footer className="bg-slate-900 rounded-xl m-4">
      <div className="mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-3">
            <h3 className="text-2xl font-bold text-white mb-4">
              Abeille Réunion
            </h3>
            <p className="text-slate-400 max-w-lg">
              La plateforme de référence pour les apiculteurs. 
              Rejoignez notre communauté et bénéficiez de tous nos services.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              À propos
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/qui-sommes-nous" className="text-slate-400 hover:text-honey-400 transition-colors">
                  Qui sommes-nous ?
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-slate-400 hover:text-honey-400 transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="text-slate-400 hover:text-honey-400 transition-colors">
                  CGU
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-slate-400 hover:text-honey-400 transition-colors">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-slate-400 hover:text-honey-400 transition-colors">
                  Confidentialité
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-honey-400 transition-colors">
                  Nous contacter
                </Link>
              </li>
              <li>
                <a href="mailto:abeillereunion@gmail.com" className="text-slate-400 hover:text-honey-400 transition-colors">
                  abeillereunion@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800">
          <p className="text-slate-400 text-sm text-center">
            © {new Date().getFullYear()} Abeille Réunion. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
